export default __webpack_public_path__ + "static/media/wechatpayColor.463a0cad.svg";